var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1177_1909",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#94A3B8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1177_1909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15C7.04167 15 6.64931 14.8368 6.32292 14.5104C5.99653 14.184 5.83333 13.7916 5.83333 13.3333V3.33329C5.83333 2.87496 5.99653 2.4826 6.32292 2.15621C6.64931 1.82982 7.04167 1.66663 7.5 1.66663H15C15.4583 1.66663 15.8507 1.82982 16.1771 2.15621C16.5035 2.4826 16.6667 2.87496 16.6667 3.33329V13.3333C16.6667 13.7916 16.5035 14.184 16.1771 14.5104C15.8507 14.8368 15.4583 15 15 15H7.5ZM4.16667 18.3333C3.70833 18.3333 3.31597 18.1701 2.98958 17.8437C2.66319 17.5173 2.5 17.125 2.5 16.6666V5.83329C2.5 5.59718 2.57986 5.39926 2.73958 5.23954C2.89931 5.07982 3.09722 4.99996 3.33333 4.99996C3.56944 4.99996 3.76736 5.07982 3.92708 5.23954C4.08681 5.39926 4.16667 5.59718 4.16667 5.83329V16.6666H12.5C12.7361 16.6666 12.934 16.7465 13.0938 16.9062C13.2535 17.0659 13.3333 17.2638 13.3333 17.5C13.3333 17.7361 13.2535 17.934 13.0938 18.0937C12.934 18.2534 12.7361 18.3333 12.5 18.3333H4.16667Z",
    fill: "#94A3B8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.fae1426fe13b9a4f9e09611314a85a62.svg";
export { ForwardRef as ReactComponent };